<template>
  <div class="container">

    <b-row class="ClientViewInfomationBox" position="fixed">
      <b-col cols="2" md="2" sm="2">
        <div class="ikona">
          <i class="fas fa-user" ></i>
        </div>
      </b-col>
      <b-col cols="10" md="10" sm="10">
        <b-row class="b-row-imie-nazw">
          <b-col>
            {{ user.name }} {{ user.surname }}
          </b-col>
        </b-row>
        <b-row class="kolumny">
          <b-col cols="7" md="7" sm="7" lg="3">
            <b-row>
              <b-col cols="12" md="12" class="NauClientViewTitle">
                Email:
              </b-col>
              <b-col style="margin-block-end:10px">
                {{ user.email }}
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="7" md="7" sm="7" lg="3">
            <b-row>
              <b-col cols="12" md="12" class="NauClientViewTitle">
                Telefon:
              </b-col>
              <b-col style="margin-block-end:10px">
                {{ user.cellphone }}
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="kolumny">
          <b-col cols="7"md="7" sm="7" lg="3">
            <b-row>
              <b-col cols="12" md="12" class="NauClientViewTitle">
                Adres:
              </b-col>
              <b-col style="margin-block-end:10px">
              {{user.street1}} {{user.building1}} <span v-if="user.flat1">/ {{user.flat1}}</span> <br> {{user.postal_code1}}, {{user.city1}}
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="7" md="7" sm="7" lg="3">
            <b-row>
              <b-col cols="12" md="12" class="NauClientViewTitle">
                Pesel:
              </b-col>
              <b-col style="margin-block-end:10px">
                {{ user.pesel }}
              </b-col>
            </b-row>
          </b-col>
        </b-row>



        <b-row>
          <b-col class="col-12 mb-3">

            <button v-if="nextLoanButton" class=" form-button d-xxl-inline-block btn btn-outline-primary btn-lg me-2" @click="nextLoan" >Kolejna Pożyczka</button>


<!--            <button class=" d-xxl-inline-block btn btn-outline-primary btn-lg me-2" @click=""  >Zmień numer telefonu</button> -->



            <button class="form-button d-xxl-inline-block btn btn-outline-primary btn-lg me-2"  @click="doPassChange" >Zmień hasło</button>

          </b-col>
        </b-row>



      </b-col>

    </b-row>
    <b-row>
      <b-col colstyle="border-style:solid; border-width:thin; background-color:whitesmoke">

        <b-table  striped hover :items="getLoansData" :fields="fields"  ref='loans_table' @refreshed="newdata" @row-clicked="clicked" >

          <template #cell(show_details)="row">


            <b-button size="sm" @click="row.toggleDetails(); getDocs(row.item.id); applySchedule(row.item.schedule);" class="mr-2" style="width:40px; background-color:#bababa; margin:0;">


              <i v-if="row.detailsShowing" class="fa fa-minus" />
              <i v-else class="fa fa-plus" />

              <!--
              {{ row.detailsShowing ? 'Pokaż' : 'Ukryj'}} <br> Szczegóły  -->
            </b-button>


          </template>

          <template #row-details="row">
            <b-card>

              <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b>Status:</b></b-col>
                <b-col>{{ !!parseInt(row.item.is_closed) ? 'Spłacona' : 'Aktywna' }}</b-col>
              </b-row>


              <div v-if="!parseInt(row.item.is_closed)">

                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right"><b>Produkt:</b></b-col>
                  <b-col>{{ row.item.template_name }}</b-col>
                </b-row>

                

                <b-row class="mb-4">
                  <b-col sm="3" class="text-sm-right"><b>Termin spłaty raty:</b></b-col>
                  <b-col>{{ !!row.item.incoming_payment && row.item.incoming_payment.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1') }}</b-col>
                </b-row>


                <b-row class="mb-4">
                  <b-col sm="3" class="text-sm-right"><b>Odbiorca przelewu</b></b-col>
                  <b-col><span  @click="copyToClipboard">Nauczycielska Agencja Ubezpieczeniowa S.A.<i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>


                <b-row class="mb-4">
                  <b-col sm="3" class="text-sm-right"><b>Nr. rachunku do przelewu:</b></b-col>
                  <b-col><span @click="copyToClipboard"> {{ row.item.loan_bank_account }} <i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>

                <b-row class="mb-4">
                  <b-col sm="3" class="text-sm-right"><b>Tytuł przelewu:</b></b-col>
                  <b-col><span @click="copyToClipboard">spłata do umowy nr. {{ row.item.contract_nbr }} <i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>

                <b-row class="mb-4">
                  <b-col sm="3" class="text-sm-right"><b>Kwota raty:</b></b-col>
                  <b-col><span @click="copyToClipboard">{{ Math.max(row.item.to_be_paid_now, row.item.incoming_payment_amount) }} <i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>

                <b-row class="mb-4">
                  <b-col sm="3" class="text-sm-right"><b>Pozostała całkowita kwota do spłaty:</b></b-col>
                  <b-col><span @click="copyToClipboard">{{ row.item.to_be_paid }} <i class="fa fa-copy copy-icon"></i></span></b-col>
                </b-row>

              </div>


              <div class="d-flex flex-column">


                <b-row v-if="!!row.item.schedule && row.item.schedule.length > 0" class="mb-4">
                  <b-col sm="3" class="text-sm-right"><b>Aktualny harmonogram:</b></b-col>
                  <b-col> <a class="plain" href="#" @click="showSchedule">Harmonogram spłat</a> </b-col>
                </b-row>

               

                


                <p v-if="!!docData && docData.length > 0"  class="HeaderDoPobrania">Do pobrania :</p>
                  <b-link class="HrefDownload" v-for="item in docData" :key="item.id" @click="download(item.id, item.document_name)">
                    {{ item.document_name }}
                  </b-link>
              </div>

            </b-card>
          </template>



        </b-table>

      </b-col>
    </b-row>




    <!-- Modal -->
    <div class="modal fade"  ref="modal">
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header container dark-bg">
            <div class="col-auto me-auto ">
              <h3>Harmongram</h3>
            </div>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body" >


            <b-row class="mb-2">
                <b-col sm="3" class="text-sm-right"><b> Data raty </b></b-col>
                <b-col><b> Kwota raty </b></b-col>
                <b-col><b> Wpłacono </b></b-col>
                <b-col><b> Pozostało </b></b-col>
            </b-row>



            <b-row v-for="r in schedule" :key='r.date' class="mb-2">
                <b-col sm="3" class="text-sm-right"><b> {{ r.date }} </b></b-col>
                <b-col>{{ r.amount }}</b-col>
                <b-col>{{ r.paid }}</b-col>
                <b-col>{{ (r.amount - r.paid).toFixed(2) }}</b-col>
            </b-row>



          </div>

          <div class="modal-footer justify-content-center">

            <button type="button" class="btn btn-lg btn-success" data-bs-dismiss="modal"> Zamknij </button>

          </div>

        </div>
      </div>
    </div>






    <PassChange />




    </div>
</template>

<script>


/*
  //import ZCVB from "./components/ZetosClientViewButtons";
  import __CFG from '@/conf/config.json';


  import axios from 'axios';
  // set to allow session cookies
  axios.defaults.withCredentials = true;
*/


  import PassChange from '@/components/PassChange.vue';



  export default {

    components: {
      PassChange
    },

    data() {
      return {


        nextLoanButton: false,

        showProcessingInfo: false,

        user: {},


        fields: [


          {
            key: 'show_details', label: '', tdClass: 'd-flex justify-content-left align-middle', thStyle: 'width: 80px;'
          },


          {
            key: 'contract_nbr', label: 'Numer Umowy', tdClass: 'align-middle'
          },

          {
            key: 'loan_date', label: 'Data Pożyczki', tdClass: 'align-middle'
          },

          {
            key: 'pay_out_ammount', label: 'Kwota', tdClass: 'align-middle'
          }


        ],


        items: [
/*          { Numer_pożyczki: "123123", Kwota_pożyczki: '2000', Data_pożyczki: "15-02-2020", termin_spłaty: "", do_spłaty: "1500" },
          { Numer_pożyczki: "123123", Kwota_pożyczki: '2000', Data_pożyczki: "15-02-2020", termin_spłaty: "", do_spłaty: "1500" },
          { Numer_pożyczki: "123123", Kwota_pożyczki: '2000', Data_pożyczki: "15-02-2020", termin_spłaty: "", do_spłaty: "1500" },
          { Numer_pożyczki: "123123", Kwota_pożyczki: '2000', Data_pożyczki: "15-02-2020", termin_spłaty: "", do_spłaty: "0" },
          { Numer_pożyczki: "123123", Kwota_pożyczki: '2000', Data_pożyczki: "15-02-2020", termin_spłaty: "", do_spłaty: "1500" },*/
        ],




        schedule: [],

        loansData: [],

        docs: [],

        modal: null


      };
    },


    computed: {


      docData(){


        let seen = [];



        return !this.docs ? [] : this.docs.filter( doc => seen.indexOf(doc.document_name) == -1 && doc.document_name.indexOf('WZOR') == -1 && seen.push(doc.document_name) ) ;
      },



      cptItems() {
        return this.items.map((item) => {
          let tmp = item;
          item.do_spłaty > 0 ? item._rowVariant = "" : item._rowVariant = 'success';
          return tmp;
        })
      }



    },
    methods: {


      doPassChange(){

        this.echo('pass_change_dialog');
      },



      nextLoan() {

        this.$router.push({path: '/fullform'});


      },



      download(downloadID, name) {


/*
          this.get('/client/document/' + downloadID, {

            responseType: 'blob'
          })
          .then((response) => {


            var fileURL = window.URL.createObjectURL(new Blob( [response.data] ));
*/

            let fileLink = document.createElement('a');

            fileLink.href = '/api/client/document/' + downloadID; // fileURL;
            fileLink.setAttribute('download', String(name).trim() + '.pdf');
            document.body.appendChild(fileLink);

            fileLink.click();



        //  });
      },

      getDocs(loanId){

          this.get('/client/documents/' + loanId)


            .then(response => {


              this.docs = response.data;

            //  console.log(this.docData)


            })
            .catch(error => {
              console.log('Network error', error);
            });
      },




      applySchedule(data){



        this.schedule = data.map( el => {let o = el.split(':'); return {'date': o[0], 'amount':o[1], 'paid':o[2]  }  });



//console.log(this.schedule);

      },



      showSchedule(){

        this.modal.show();
      },


      
      clicked(row){

        row._showDetails = !row._showDetails;
      },


      newdata(){

///console.log('rows loaded')

//console.log(this.$refs)

      },

      getLoansData (ctx, callback) {


              // load clients contracts
              this.get('/client/loans')

                .then(response => {

                  let items = [], 
                    first = true,
                    skipCounter = 0;



                  if (!response.data) {

                    items = [];
                  }
                  else {


                    // lets see if we have some loans under processing
                    response.data.map( l => {


                      parseFloat(l.status_id) == 1.1 && (this.showProcessingInfo = true);


                      // activate repay button if loan found active loan
                      //!this.repayLoanButton && parseFloat(l.status_id) >= 3 && parseFloat(l.status_id) < 4 && !parseInt(l.is_closed) && (this.repayLoanButton = true);


                      !!l.template_name && l.template_name.match(/13-stka/) && skipCounter++;


                    });



                    // allow next loan
                    this.nextLoanButton = !parseInt(this.user.rejected_loan_no) && parseInt(this.user.active_loan_no) <= skipCounter;



//console.log(response.data);


                    items = response.data.filter( l => {

                      const sid = parseFloat(l.status_id);

                      return ((sid >= 3 || sid == 1.05) && !parseInt(l.is_closed));

                    }).map( l => {

                      /*l._showDetails = first;

                      if (first) {
                        this.getDocs(l.id);
                      }

                      first = false;*/




                      l.schedule = !l.pending_installments ? [] : l.pending_installments.split(',');



                      l.loan_date = l.loan_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');

                      l.pay_out_ammount = parseInt(l.pay_out_ammount);

                      l.contract_nbr += !!parseInt(l.is_closed) && parseInt(l.status_id) >= 3 ? ' - spłacona' : parseFloat(l.status_id) == 1.05 ? ' - wniosek' : '';          

                      return l;
                    })
                  }

        


                  callback(items);

                })
                .catch(error => {
                  callback([]);
                });


                // Must return null or undefined to signal b-table that callback is being used
                return null
            }



    },


    created() {



      this.user = JSON.parse(localStorage.getItem('user'));


      // no active loans and no rejections so activate next loan button
      this.nextLoanButton = !parseInt(this.user.rejected_loan_no) && !parseInt(this.user.active_loan_no);


/*
      this.get('/client/loans')

        .then(response => {

          //let row = ['contract_nbr', '']


          if (!response.data) {

            this.loansData =  [];
          }
          else {

            this.loansData = response.data;

            this.items = this.loansData.filter( l => parseFloat(l.status_id) >= 3 && parseFloat(l.status_id) < 4 ).map( l => {


              l.loan_date = l.loan_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');

              l.pay_out_ammount = parseInt(l.pay_out_ammount);


              l.contract_nbr += !!parseInt(l.is_closed) ? ' - spłacona' : '';

              // some mods to data

              return l;
            });

          }



        })
        .catch(error => {
          console.log('Network error', error);
        });

*/



    },

    mounted() {



        this.modal = new bootstrap.Modal(this.$refs['modal']);


    }
  }
</script>


<style scoped>

  .HeaderDoPobrania{
    margin-block-end:20px;
    font-weight:bold;
  }
  .fa-user {
    font-size: 80px;
    border-radius: 100px;
    box-shadow: 0px 0px 5px white;
    padding: 0.5em 0.6em;
  }


  .ikona {

    margin-top:35px;
    justify-content: center;
    text-align: center;
  }


  .NauClientViewTitle {
    color: #0BC268;
  }




  .btn {
    text-decoration-style: solid;
    font-size: 17px;
    width: 230px;

  }
  .HrefDownload{
    margin-block-end:20px;
  }

  @media (max-width: 575px) {
    .NauClientViewTitle {
      font-size: 15px
    }
    .ikona {
      justify-content: right;
      text-align: right;
      margin-top:1px;
    }
    .fa-user {
      opacity:0;
    }
    .btn {
      color: white;
      text-decoration-style: solid;
      background-color: transparent;
      font-size: 17px;
      width: 230px;
      margin-block-end: 16px;

    }
  }
  @media (max-width: 991px) {
    .NauClientViewTitle {
      font-size: 15px

    }
    .fa-user {
      font-size: 26px;
    }
    .ikona {
      justify-content: right;
      text-align: right;
      margin-top: 10px;
    }
  }
  .b-row-imie-nazw{
    margin-top:.3em;
    font-size: 2.4rem;
    text-decoration-style:solid;
    margin-block-end: 8px;
    text-align:left;
  }
  .kolumny {
    width: 100%;
  }
 .b-col{
   display:flex;
 }


 .copy-icon {

    color: #045439;
    padding-left:1rem;
 }


</style>



// WEBPACK FOOTER //
// src/ZetosClientView.vue